import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { useSelector } from 'react-redux';
import * as S from './popularBusRoutes.styles';
import { homeFaqDataSelector } from './../../../../containers/Home/redux/selectors';
import Icon from './../../../../../stories/core-components/IconsSelector';
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils' 

const ctaEventCaller = () => {
  pushCtaOmniEvents('Popular Bus Routes', CTA_TYPE.HYPER_LINK, 'Dweb_home', 'SRP Page');
}

const PopularBusRoutes = props => {
  const { faqData } = useSelector(homeFaqDataSelector);
  if (faqData && faqData.data && faqData.data.template && faqData.data.template.interlinks) {
    const bus_route_interlinks = faqData.data.template.interlinks[0].bus_route_interlinks;
    let viewData = getViewData(bus_route_interlinks);

    return (
      <S.PopularBusRoutes>
        <p key={Math.random()} dangerouslySetInnerHTML={{
          __html: bus_route_interlinks.title
        }}></p>
        <S.RouteBlock>
          <div onClick={ctaEventCaller}>
          <ul>
            {viewData}
          </ul>
          </div>
        </S.RouteBlock>
      </S.PopularBusRoutes>
    );
  } else {
    return null;
  }
};
export default PopularBusRoutes;

function getViewData(data) {
  const { links } = data;
  let viewData = [];

  for (const i in links) {
    const item = ReactDOMServer.renderToStaticMarkup(<Icon name='BusIcon' styleProps={{ fill: '#647A97', width: '2.5rem', height: '2.5rem' }} />);
    viewData.push(
      <li key={i + "busroutes"}>
        {/* <S.BusIcon></S.BusIcon> */}
        <S.BusDetails>
          <S.CardWrapper>
            <Icon name='BusIcon' styleProps={{ fill: '#647A97', width: '2.5rem', height: '2.5rem' }} />
            <div>
              <S.CardHeader
                dangerouslySetInnerHTML={{
                  __html: `${links[i].heading}`
                }}
              >
              </S.CardHeader>
              <S.SmallTxt dangerouslySetInnerHTML={{
                __html: links[i].subheading
              }}>
              </S.SmallTxt>
            </div>
          </S.CardWrapper>
        </S.BusDetails>
      </li>
    )
  }
  return viewData;
}
